<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
    <div class="center-table-list" style="position:relative;margin-left: 0px;margin-right: 0px;">
        <div class="table-list" style="margin-top:25px">
            <div class="table-list-title">
                <span style="margin-left:25px">取证宝</span>
                <div class="choose-group">
                    <!-- <span class="choose-group-span">时间</span> -->
                    <Date-picker :value="dateVal" format="yyyy-MM-dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 180px" @on-change="changeDate"></Date-picker> 
                    <!-- <span class="choose-group-span">类型</span> -->
                    <i-select placeholder="全部类型" style="width:100px;margin:0 5px;" @on-change="selectType">
                        <i-option value="all">全部类型</i-option>
                        <i-option value="1">网页取证</i-option>
                        <i-option value="2">录屏取证</i-option>
                        <i-option value="3">APP拍照取证</i-option>
                        <i-option value="4">APP录像取证</i-option>
                        <i-option value="5">APP录屏取证</i-option>
                        <i-option value="6">APP录音取证</i-option>     
                        <i-option value="7">桌面录屏取证</i-option>   
                    </i-select> 
                    <!-- <span class="choose-group-span">状态</span> -->
                    <i-select placeholder="全部状态" style="width:100px" @on-change="selectValues">
                        <i-option value="all">全部状态</i-option>
                        <i-option value="0">排队中</i-option>
                        <i-option value="1">取证中</i-option>
                        <i-option value="2">取证完成</i-option>
                        <i-option value="3">取证失败</i-option>
                        <i-option value="6">数据处理中</i-option>   
                    </i-select>
                    <div class="father-box-input" style="margin:0 5px">
                        <input v-model="detailSeqNo" placeholder="按订单编号搜索" class="select-input-self"  @keyup.enter="changeName" />
                        <img src="@/assets/search.png" class="search-icon" @click="changeName" alt='版权登记'/>
                    </div>  
                    <div class="father-box-input" style="margin-right:5px;margin-left:0px;">
                        <input v-model="keywords" placeholder="按取证名称搜索" class="select-input-self"  @keyup.enter="changeName" />
                        <img src="@/assets/search.png" class="search-icon" @click="changeName" alt='版权登记'/>
                    </div>  
                                     
                    <button class="btn-84" @click="changeName" style="margin-right:10px">查询</button>
                </div>
            </div>            
            <Row class="table-style-size">
                <i-col span="5">订单编号</i-col>
                <i-col span="3">取证名称</i-col>
                <i-col span="2">取证类型</i-col>
                <i-col span="2">消耗次数/分钟</i-col>
                <i-col span="3">申请人</i-col>
                <i-col span="3">提交时间</i-col>
                <i-col span="2">订单状态</i-col>
                <i-col span="4">操作</i-col>
            </Row>
            <div v-if="records.length>0">
                <Row class="table-style-size table-style-body" style="height:90px"  v-for="(item,index) in records" :key="index">   
                    <i-col span="5">{{item.detailSeqNo}}</i-col>
                    <i-col span="3">
                        <Tooltip :content="item.name" placement="top"><span style="display:inline-block;width:138px;height:21px;vertical-align:middle" class="notwrap">{{item.name}}</span></Tooltip>
                    </i-col>
                    <i-col span="2">{{item.orderTypeCh}}</i-col>
                    <i-col span="2" v-if="item.orderType==1 || item.orderType==3">{{item.orderCount?item.orderCount+'次':'0次'}}</i-col>
                    <i-col span="2" v-else>{{item.orderTime?item.orderTime+'分钟':'0分钟'}}</i-col>
                    <i-col span="3">
                        <Tooltip :content="item.registerName" placement="top"><span style="display:inline-block;width:138px;height:21px;vertical-align:middle" class="notwrap">{{item.registerName}}</span></Tooltip>
                    </i-col>
                    <i-col span="3">{{item.createDate}}</i-col>
                    <i-col span="2">{{item.statusCh}}</i-col>
                    <i-col span="4" v-if="item.status==4">已失效</i-col>
                    <i-col span="4" v-else>
                        <button class="btn-84" @click="pushInfo(item)">详情</button>
                        <!-- <div class="showphotow" v-if="item.status==3" style="margin-left:0px"><button class="btn-84" :style="{display: item.orderType==1 || item.orderType==2 ||item.orderType==7?'inline-block':'none' }" @click="resubmit(item)">重新取证</button></div> -->
                        <div class="showphotow" style="margin-left:8px">
                            <button class="btn-84">更多操作</button>
                            <div class="showdiasy">
                                <p @click="openVerify(item)" :style="{cursor:item.status==2?'pointer':'not-allowed',display:item.downloadFileFlag=='0'?'none':'block'}" >下载证据</p>
                                <p @click="downCert(item)" :style="{cursor:item.status==2?'pointer':'not-allowed'}">查看证书</p>
                                <p @click="downBcBook(item)" :style="{cursor:item.status==2?'pointer':'not-allowed'}">下载BC文件</p>
                            </div>
                        </div>                       
                    </i-col>
                </Row>
                <div class="commont-page" style="position:absolute;bottom:10px;left:50%;transform:translate(-50%, -50%)">
                    <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" :current="pageNumber" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
                </div>
            </div>
            <div class="empty-box" v-if="records.length<=0&&flag">
                <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
                <p>表单暂无数据哦～</p>
            </div>
        </div>
    </div>
    
</template>

<script>
import { _updateTitle,_getEvidenceList,_getPackageFile,_getCertFile,_getBcFile } from "@/api/evidence.js";
import Cookies from "js-cookie";
export default {
    name:'myEvidence',
    data(){
    return{
        orderType:"",
        orderStatus:"",
        detailSeqNo: "",
        keywords: "",
        total:0,
        pages:0,
        pageNumber:1,
        pageSize:6, 
        records:[],
        dateVal:[],
        beginTime:"",
        endTime:"",
        nameVal:"",
        currentIndex:null,
        titleVal:"",
        flag:false,
        flagType:1,
    }
  },
  methods: {
    getByPage(){ 
        let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';   
        const data = {
            account:userInfo && userInfo.account?userInfo.account:'',
            orderType: this.orderType,
            keywords: this.keywords,
            status: this.orderStatus,
            detailSeqNo: this.detailSeqNo,
            startTime: this.dateVal.length>0?this.dateVal[0]:"",
            endTime: this.dateVal.length>0?this.dateVal[1]:"",
            pageNo: this.pageNumber,
            pageSize: this.pageSize,
        }
        _getEvidenceList(data).then(res => {
            if(res.code==200){
                this.total=Number(res.totalCount);
                this.pages=res.totalPage;
                this.records=res.evidenceList;
                this.flag=true;
            }
        });            
    },
    //分页
    changepage(index){
        this.pageNumber = index
        this.getByPage()
    },
    //日期
    changeDate(val){
        this.dateVal = val;
        this.pageNumber=1;
        this.getByPage()
    },
    //证书编号
    searchFun(){
        this.pageNumber=1;
        this.getByPage()
    },
    //搜索名称
    changeName(){
        this.pageNumber=1;
        this.getByPage()
    },
    //编辑标题
    editeRemark(index,name){
        console.log(index)
        this.currentIndex=index;
        this.titleVal=name
    },
    //全部类型
    selectType(val){
        console.log('这是获取的类型',val)
        this.orderType = val=='all'?'':val;
        this.pageNumber=1;
        this.getByPage()
    },
    //全部状态
    selectValues(val){
        this.orderStatus = val=='all'?'':val;
        this.pageNumber=1;
        this.getByPage()
    },
    changeTitle(id,orderSeqNo){
        let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';    
        const data = {
            id:id,
            registerId:userInfo && userInfo.id?userInfo.id:'',
            orderSeqNo:orderSeqNo,
            name:this.titleVal
        }
        _updateTitle(data).then(res => {
            if(res.code==200){
               this.currentIndex=null;
               this.getByPage()
            }
        });        
    },
    //详情
    pushInfo(item){
        this.$router.push({name:'tortInfo',params:{type:item.orderType,id:item.detailSeqNo}})
    },
    //重新取证
    resubmit(item){
        console.log(item)
    },
    //证据包
    downUrl(item){
         if (item.packageUrl) {
            const links = item.packageUrl;
            let aDom = document.createElement("a");
            aDom.target = "_self";
            aDom.href = links;
            aDom.download = links.substr(links.lastIndexOf('/'), links.length);
            aDom.click();
        }
      },
    //下载Bc
    downBcBook(item){
        _getBcFile({
            orderType: item.orderType,
            detailSeqNo: item.detailSeqNo
        }).then((res) => {
            const data = res;
            if (data.code == '200') {
                if (data.bcUrl) {
                    window.open(data.bcUrl,'_self')
                }
            } else {
                toast(data.message);
            }
        }).catch(function (error) {
            console.log(error);
        })    
    },
    //下载证据
    openVerify(item){
        if (item.status != 2) {
            return false;
        }
        _getPackageFile({
            orderType: item.orderType,
            detailSeqNo: item.detailSeqNo
        }).then((res) => {
            if (res.code == '200') {
                if (res.url) {
                    // const links = data.url;
                    // let aDom = document.createElement("a");
                    // aDom.target = "_blank";
                    // aDom.href = links;
                    // aDom.download = links.substr(links.lastIndexOf('/'), links.length);
                    // aDom.click();
                    window.open(res.url,'_self')
                }
            } else {
                toast(res.message);
            }
        }).catch(function (error) {
            console.log(error);
        })
    },
    //查看证书
    downCert(item){
        _getCertFile({
            orderType: item.orderType,
            detailSeqNo: item.detailSeqNo
        }).then((res) => {
            const data = res;
            if (data.code == '200') {
                if (data.certUrl) {
                    window.open(data.certUrl,'_blank')
                }
            } else {
                toast(data.message);
            }
        }).catch(function (error) {
            console.log(error);
        })
    },
    newOpen(){
        window.open('/evidenceWeb', '_blank');
    }
  },
  mounted() {
    this.getByPage()
  },
    }
</script>
<style scoped lang="less">
.bianji{
    position: relative;
    top:-7px;
    cursor: pointer;
}
.editeRemark{
    display: inline-block;
    width:220px;
    height:38px;
    background:rgba(255,255,255,1);
    border-radius:18px;
    border:1px solid rgba(229,231,234,1);
    margin-bottom: 7px;
    .editeRemark-input{
        height: 36px;
        border:0px;
        background:transparent;
        outline: none;
        color:#666;
        margin-left: 10px;
        font-size: 14px;
        width:175px;
        font-weight: 400;
        vertical-align: middle;
    }
    .editeRemark-search-icon{
        width:20px!important;
        height:20px!important;
        vertical-align: middle;
        cursor: pointer;
    }
}
.showphotow{
    display: inline-block;
    height: 100%;
    position:relative;
    margin-left: 20px;
    .showdiasy{
      position:absolute;
      top:35px;
      left:0px;
      background: #fff;
      box-shadow: 0 2px 18px 0 rgba(179,189,199,.47);
      border-radius: 4px;
      z-index:777;
      width: 110px;
      display:none;
      p{
        height:30px;
        line-height:30px;
        cursor:pointer;
        font-size: 12px;
        background-color: #fff;
        color: #929292;
      }
      a{
        color: #929292;
      }
      a:hover{
        color: #4e4e4e;  
      }
      p:hover{
        background-color: #f7f9fb;
        color: #4e4e4e;
      }
    }
    &:hover{
      .showdiasy{
        display:block;
      }
    }
  }
</style>